import styled from 'styled-components';
import * as CSS from 'csstype';
import ArrowBlueDownSvg from '../assets/blue-down-icon.svg';

const ArrowBlueDown = styled(ArrowBlueDownSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1rem'};
  height: ${props => props.height || '1rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowBlueDown;
